import TableItem from "./TableItem";
import "./sumResult.css"

const SumResult = (props) => {
    const {result, counts} = props 

    
      
    const countedResult = result.map((item, index) => {
      const totalResources = [item.wood*counts[index],
                              item.clay*counts[index],
                              item.iron*counts[index],
                              item.crop*counts[index],
                              item.all*counts[index]]
      return{totalResources}
    })

    const resourceSums = { 
      name: "Total",
      wood: 0,
      clay: 0,
      iron: 0,
      crop: 0,
      all: 0
    }
    
    countedResult.forEach((item) => {
      resourceSums.wood += item.totalResources[0]
      resourceSums.clay += item.totalResources[1]
      resourceSums.iron += item.totalResources[2]
      resourceSums.crop += item.totalResources[3]
      resourceSums.all += item.totalResources[4]
    })
    
    

return (
    <div className="sum">
      <TableItem item={resourceSums} count="1" />
        
    </div>
)

}
export default SumResult